import axios from "vue-app/utils/axios";
import { DTOActionRequiredNotification } from "./dto";

export const getDashboardNotifications = async () => {
  const { data } = await axios.get<Array<DTOActionRequiredNotification>>("/notification/dashboard");
  return data;
};
